import { axiosInstance } from '~/services';

import type {
  TypeGetOwnerSupplierOwnerSupplierCodeParams,
  TypeGetOwnerSupplierOwnerSupplierCodeResponse,
} from '~/types/vender.types';

/**
 * [화주사정보관리 > 공급사관리] 공급사 상세 조회
 */
const useGetOwnerSupplierOwnerSupplierCode = () => {
  const endPoint = '/api-owner/owner-supplier';

  const getOwnerSupplierOwnerSupplierCode = async ({
    ownerSupplierCode,
  }: TypeGetOwnerSupplierOwnerSupplierCodeParams) => {
    return axiosInstance
      .get<TypeGetOwnerSupplierOwnerSupplierCodeResponse>(`${endPoint}/${ownerSupplierCode}`)
      .then(({ data }) => {
        return data.data;
      })
      .catch((error) => {
        throw error;
      });
  };

  return { getOwnerSupplierOwnerSupplierCode };
};

export default useGetOwnerSupplierOwnerSupplierCode;
